import { MARKETPLACE_SEARCH_PANEL } from '../constants/EmbedFrame';
import { MARKETPLACE_EMBED } from '../constants/EmbedGroup';
import { useOpenExternalLinkReceiver } from '../messaging/openExternalLink.message';
import { useFullscreenReceiver } from '../messaging/useFullscreen.message';
import { useMessageReceivers } from '../messaging/useMessageReceivers';
import { getHostAppName } from '../utils/getHostAppName';
import { getIFrameSrc } from '../utils/getIFrameSrc';

// @ts-expect-error untyped dependency
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MarketplaceSearchPanel({
  appName,
  className,
  embedQuery,
  offeringSlug,
  onOpenStart,
  onOpenComplete,
  onClose,
  onReady,
  onReadyError,
  panelTitle,
  preload,
  searchPlaceholder,
  show
}) {
  const {
    offeringType
  } = embedQuery;
  const openExternalLinkReceiver = useOpenExternalLinkReceiver();
  const {
    fullscreen,
    screenSize,
    receiver: fullscreenReceiver
  } = useFullscreenReceiver();
  const receiveMessage = useMessageReceivers(openExternalLinkReceiver, fullscreenReceiver);
  const path = offeringSlug ? `search-panel/details/${offeringSlug}` : 'search-panel';
  return /*#__PURE__*/_jsx(UIModalIFrame, {
    appName: appName || getHostAppName(),
    className: className,
    "data-test-id": "marketplace-search-panel",
    embeddedPassthruProps: {
      embedQuery,
      offeringType,
      panelTitle,
      searchPlaceholder
    },
    group: MARKETPLACE_EMBED,
    height: "100%",
    iframePassthruProps: {
      'data-test-id': 'marketplace-search-panel-iframe'
    },
    name: MARKETPLACE_SEARCH_PANEL,
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    onClose: onClose,
    onMessage: receiveMessage,
    onReady: onReady !== null && onReady !== void 0 ? onReady : () => {},
    onReadyError: onReadyError,
    preload: preload,
    show: show,
    src: getIFrameSrc(path)
    // switching from 'panel' to 'fullscreen' mode causes the iframe to remount
    ,
    use: "panel"
    // so instead we use the screen size to set the width
    ,
    width: fullscreen ? screenSize.width : '500'
  }, path);
}